import axiosService from "../api/axios";

export const getFaqService = () => {
  return axiosService.get("/faq/publish-faq");
};
